import React, { PropsWithChildren, useEffect, useMemo } from 'react';
import { ROUTER, RouterContextProvider } from '@cp/shared/router';
import { useLocation } from 'react-router';
import { createPageViewEvent } from '@cp/shared/tracking';
import { useInjection } from '@cp/shared/di';
import { useTracking } from 'src/shared/tracking';

let lastTracked: string = '';

export const RouterProvider: React.FC<PropsWithChildren> = (props) => {
  // const config = useConfig();
  // const history = useHistory();
  const location = useLocation();
  const pageView = useTracking(createPageViewEvent);
  const router = useInjection(ROUTER);

  useEffect(() => {
    if (lastTracked === location.pathname) {
      return;
    } else {
      lastTracked = location.pathname;
    }
    // send event
    pageView({ url: window.location.href, path: location.pathname, title: document.title });
  }, [location.pathname, pageView]);

  return <RouterContextProvider value={router}>{props.children}</RouterContextProvider>;
};
